import React from 'react'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text'

import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import ListItem from 'app/ProfileRevampPage/components/SectionKarya/CeritaPraktik/ListItem'
import { useLayoutState } from 'app/ProfileRevampPage/hooks/useLayoutState'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { getUserDisplayName } from 'utils/user'

const CeritaPraktikSection = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { profileData, ceritaPraktikCount } = useProfile()
  const { hasCeritaPraktik } = useLayoutState()

  const userDisplayName = getUserDisplayName(profileData?.name ?? '')

  return (
    <div className="px-4 pt-6 pb-3" {...props}>
      <div className="flex space-x-2 items-center mb-3">
        <NextImage
          layout="fixed"
          src="/icon/ide-praktik.svg"
          alt="Cerita Praktik"
          width="24px"
          height="24px"
        />
        <Text variant="heading-md">Cerita Praktik</Text>
      </div>

      {hasCeritaPraktik ? (
        <>
          <div className="mb-4">
            <Text variant="helper" color="subdued">
              Menampilkan {ceritaPraktikCount} Cerita Praktik terbaru{' '}
              {userDisplayName}
            </Text>
          </div>

          {(profileData?.ceritaPraktik ?? []).map((props, index) => (
            <ListItem
              data-testid="profile-cerita-praktik-list-item"
              key={`profile-cerita-praktik-${index}`}
              index={index}
              {...props}
            />
          ))}
        </>
      ) : (
        <EmptyStateWithAction
          description="Belum ada Cerita Praktik yang Anda tulis. Kalau ada, akan muncul di sini."
          className="p-3 bg-surface-neutral-subdued rounded-[4px]"
        />
      )}
    </div>
  )
}

export default CeritaPraktikSection
